import * as tslib_1 from "tslib";
/** @jsx jsx */

import { jsx } from "@emotion/core";
import * as React from "react";
import { Spinner } from "./Spinner";
import PropTypes from "prop-types";
import { useTheme } from "./Theme/Providers";
export var Layer = React.forwardRef(function (_a, ref) {
  var _b = _a.elevation,
      elevation = _b === void 0 ? "md" : _b,
      children = _a.children,
      other = tslib_1.__rest(_a, ["elevation", "children"]);

  var theme = useTheme();
  return jsx("div", tslib_1.__assign({
    ref: ref,
    css: {
      position: "relative",
      background: theme.colors.background.layer,
      boxShadow: theme.shadows[elevation],
      borderRadius: theme.radii.lg
    }
  }, other), children);
});
Layer.displayName = "Layer";
Layer.propTypes = {
  elevation: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl"]),
  children: PropTypes.node
};
export var LayerLoading = function LayerLoading(_a) {
  var loading = _a.loading,
      label = _a.label,
      other = tslib_1.__rest(_a, ["loading", "label"]);

  var theme = useTheme();
  var isDark = theme.colors.mode === "dark";
  return jsx("div", tslib_1.__assign({
    css: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      borderRadius: theme.radii.lg,
      bottom: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: isDark ? "rgba(0,0,0,0.75)" : "rgba(255,255,255,0.7)",
      zIndex: 5,
      transition: "opacity 0.3s ease",
      pointerEvents: loading ? "auto" : "none",
      opacity: loading ? 1 : 0
    }
  }, other), jsx(Spinner, {
    label: label
  }));
};
LayerLoading.propTypes = {
  loading: PropTypes.bool
};